import React, {Component} from 'react';
import _ from "i18n";
import {connect} from "react-redux";
import {castArray, filter, includes, map, range} from "lodash";
import {fetchDocumentsAppRef} from "../../../actions/thunks/documents"
import {displayCodaFileTestfFile} from "../../../actions/thunks/organizationConfiguration"
import {setStatisticsEventsFilter} from "../../../actions/actions/statistics";
import {fetchDocumentsApp} from "../../../actions/thunks/documents"
import {reactSelectStyles, urlFiltersParser, updateUrlFilter} from 'utils';
import Select, {components} from "react-select";
import moment from 'moment';
import queryString from "query-string";
import CreatableSelect from 'react-select/lib/Creatable';
import __ from "lodash";
import {setCurrentNavPage} from "actions";
import SidePageHeader from "../../common/SidePageHeader";
import {Button} from "antd";


class ImportCodaTesting extends Component{

  constructor(props) {
    super(props);

    this.state = {
      appRefs: " ",
    };
  }

  handleChange = (value) => {
    this.setState({appRefs: value});

  };

  componentDidMount() {

    this.props.setCurrentNavPage("IMPORT-CODA-TESTING");
    this.props.fetchDocumentsAppRef(this.props.auth.currentClient ? this.props.auth.currentClient.id : null, null, ['registering'])
  }


  getCodaFile = () => {
    this.props.displayCodaFileTestfFile(this.state.appRefs.value)
  }
  render() {
    const  organization = this.props.auth.currentClient ? (this.props.auth.currentClient.abbreviation ? this.props.auth.currentClient.abbreviation : this.props.auth.currentClient.name) : "";
    const defaultValue = [];
    let propsApp = [];
    propsApp = castArray(this.props.appRef);
    if (propsApp){
      propsApp.forEach(item => {
        defaultValue.push({value: item.id+"", label: item.nameFr, color: "#2495E1"});
      });

    }

    return (
      <div className="organization-configuration">
        <SidePageHeader subHeader={_("Import Coda Testing")} app="payment" organization = {organization}/>
        <div>
          <h5 className="text-black text-center mb-6"> {_("import-coda-test")} </h5>
        </div>
        <div style={{marginRight : "35%" , marginLeft: "35%"}}>
      <Select
      styles={reactSelectStyles()}
      className='react-select-container nav_select_app_ref'
      classNamePrefix="react-select"
      placeholder={_('CHOOSE-EVENEMENT')}
      closeMenuOnSelect={true}
      options={defaultValue}
      components={components.Group}
      onChange={this.handleChange}
      value={this.state.appRefs}
    /></div>

        <div className = "text-center" style={{width : "20%" , marginLeft : "36rem"}}>
          <Button disabled={this.state.appRefs === " "} className="w-48  m-2 mt-4 text-center" type="primary" onClick={this.getCodaFile}>{_("upload") }</Button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  appRef: state.appRefFilter.items,
  statisticsFilter: state.filters.statisticsFilter,
  auth: state.auth,

});

const mapDispatchToProps = {
  fetchDocumentsAppRef,
  setCurrentNavPage,
  displayCodaFileTestfFile
};

export default connect(mapStateToProps, mapDispatchToProps)(ImportCodaTesting);



// WEBPACK FOOTER //
// ./app/components/Admin/OrganizationConfiguration/ImportCodaTesting.js